// ** react imports
import React from 'react';

// ** sentry imports
import * as Sentry from "@sentry/react";

// ** react dom imports
import ReactDOM from 'react-dom/client';

// ** redux imports
import { Provider } from 'react-redux';

// ** routers imports
import { BrowserRouter as Router } from 'react-router-dom';

// ** theme context imports
import ThemeProvider from './contexts/ThemeContext';

// ** app imports
import App from './App';

// ** redux store imports
import store from './redux';

// ** remixicon imports
import 'remixicon/fonts/remixicon.css';

Sentry.init({
  dsn: process.env.SENTRY_DSN, 
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 0.2,          
  replaysSessionSampleRate: 0.05, 
  replaysOnErrorSampleRate: 1.0,  
  environment: process.env.NODE_ENV || "development",
});



ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider>
        <Router>
          <App />
        </Router>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);
